import { useState } from 'react'
import { sanitizeImageUrl } from '../imageUrl'
import type { PriceBoardProps } from '../Types'

export default function PriceBoard({ flightsHot, allFlights }: PriceBoardProps) {
  const currencySymbol = window.siteVar?.referer === 'IE' ? '€' : '£'
  const [selectedContinent, setSelectedContinent] = useState('')

  const continentDestinations = selectedContinent
    ? (allFlights.find(c => c.adv_cont === selectedContinent)?.destinations ?? []).slice(0, 6)
    : []

  const continentSlug = continentDestinations[0]?.cat_category ?? '#'

  return (
    <section className="app-section app-section-grey container-fluid px-4 py-5 pt-md-5 px-md-0" id="price-board">

      <div className="container d-flex justify-content-center p-0 m-0 mx-auto">
        <div className="container row text-start pb-4 px-0">
          <h4 className="fw-bold fs-5 fs-md-4 col p-0">Our best value flights this week</h4>
          <button
            className="btn rounded-0 btn-lg col-2 col-md-3 d-none d-md-block bg-tf-orange text-white"
            onClick={() => document.getElementById('flightsearch')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Search Flights
          </button>
        </div>
      </div>

      <div className="container bg-dark px-0">
        <div className="row pb-3 pb-md-0">

          <div className="col-8 col-md-3 p-5">
            <h6 className="text-light opacity-75">Destination</h6>
            {flightsHot.map((flight, i) => (
              <p key={i} className="fares-board text-white">{flight.adv_dest}</p>
            ))}
            {flightsHot.some(f => !f.adv_total) && (
              <div className="position-absolute">
                <p className="text-muted fs-7">NOTE: N/A - call for latest prices</p>
              </div>
            )}
          </div>

          <div className="col-4 col-md-1 pt-5">
            <h6 className="text-light opacity-75">Price ({currencySymbol})</h6>
            {flightsHot.map((flight, i) => (
              <p key={i} className="fares-board fares-board-yellow">{flight.adv_total}</p>
            ))}
          </div>

          <div className="col-12 col-md-4 px-5 pt-0 pb-2 p-md-5">
            <h5 className="text-white d-md-none d-block">For more flights choose a region:</h5>
            <select
              className="form-select"
              aria-label="Airfare region select"
              value={selectedContinent}
              onChange={e => setSelectedContinent(e.target.value)}
            >
              <option value="" disabled>Select a region</option>
              {allFlights.map((continent, i) => (
                <option key={i} value={continent.adv_cont}>{continent.adv_cont}</option>
              ))}
            </select>

            <div className="row flex-column h-100">
              {continentDestinations.length === 0 && selectedContinent && (
                <div className="col-12 pt-5">
                  <p className="fares-board text-white">No destinations found.</p>
                </div>
              )}
              {continentDestinations.length > 0 && (
                <>
                  <div className="d-flex justify-content-between">
                    <h6 className="text-light opacity-75 pt-4">{selectedContinent}</h6>
                    <h6 className="text-light opacity-75 pt-4">Price ({currencySymbol})</h6>
                  </div>
                  {continentDestinations.map((dest, i) => (
                    <div key={i} className="d-flex justify-content-between">
                      <div className="fares-board text-white">{dest.adv_dest}</div>
                      <div className="fares-board fares-board-yellow">{dest.adv_total || 'N/A'}</div>
                    </div>
                  ))}
                  <button
                    className="btn btn-outline-light rounded-0 mt-3"
                    onClick={() => window.location.href = `/flights/${continentSlug}`}
                  >
                    View All {selectedContinent}
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="col-4 d-none d-md-block">
            <img
              src={sanitizeImageUrl('https://cdn.trailfinders.com/wqheylpseb_shutterstock_506775598%2520(1)_960x960.jpg', { width: 500 })}
              className="img-fluid w-100 h-100"
              style={{ height: 400, objectFit: 'cover' }}
              alt=""
            />
          </div>

        </div>
      </div>
    </section>
  )
}
